import { IonCard, IonCardContent, IonCol, IonRow, IonSelectOption } from '@ionic/react';
import { barcodeOutline, locationOutline, mailOutline, maleOutline, personOutline } from 'ionicons/icons';
import { useState } from 'react';

import InputItem from '../../../components/input/InputItem';
import SlideContent from '../../../components/slide-content/SlideContent';
import RadioItem from '../../../components/radio/RadioItem';

interface Props {
    formProvider: any,
    cardStatus: string,
    provinces: any
}

const Section2: React.FC<Props> = (props) => {
    let disabled = !(props.cardStatus != 'paid' && props.cardStatus != 'queued' && props.cardStatus != 'printing' && props.cardStatus != 'issued');

    let provinceIndex = props.provinces?.findIndex((item: any) => {
        return item.name == props.formProvider.form.province.value
    })

    const onProvinceChange = () => {
        let form = { ...props.formProvider.form }
        form.city.value = '';
        props.formProvider.setForm(form)
    }

    return <SlideContent type="navbar" class="section2">
        <IonCard>
            <IonCardContent>
                <IonRow>
                    <IonCol>
                        <h3 className="ion-padding-bottom">تکمیل موارد زیر اجباری است.</h3>

                        <InputItem name="name" type="text" label="نام" icon={personOutline} maxlength={25} provider={props.formProvider} disabled={disabled} />

                        <InputItem name="family" type="text" label="نام خانوادگی" icon={personOutline} maxlength={25} provider={props.formProvider} disabled={disabled} />

                        <InputItem name="gender" type="select2" label="جنسیت" icon={maleOutline} provider={props.formProvider} disabled={disabled}>
                            <RadioItem value="1" label='مرد' isChecked={props.formProvider.form.gender.value == "1"}/>
                            <RadioItem value="2" label='زن' isChecked={props.formProvider.form.gender.value == "2"} />
                        </InputItem>

                        <InputItem name="province" type="select2" label="استان" icon={locationOutline} provider={props.formProvider} change={onProvinceChange} disabled={disabled}>
                            {props.provinces?.map((item: any) => {
                                return <RadioItem key={item.name} value={item.name} label={item.name} isChecked={props.formProvider.form.province.value == item.name} />
                            })}
                        </InputItem>

                        <InputItem name="city" type="select2" label="شهر" icon={locationOutline} provider={props.formProvider} disabled={disabled}>
                            {props.provinces && Object(props.provinces[provinceIndex]).Cities?.map((item: any) => {
                                return <RadioItem key={item.name} value={item.name} label={item.name} isChecked={props.formProvider.form.city.value == item.name} />
                            })}
                        </InputItem>

                        <InputItem name="national_code" type="tel" label="کد ملی" icon={barcodeOutline} maxlength={10} ltr spaced provider={props.formProvider} disabled={disabled} />

                        <InputItem name="address" type="textarea" label="آدرس" icon={locationOutline} maxlength={100} provider={props.formProvider} disabled={disabled} />

                        <InputItem name="postal_code" type="text" label="کد پستی" icon={mailOutline} maxlength={10} ltr spaced provider={props.formProvider} disabled={disabled} />
                    </IonCol>
                </IonRow>
            </IonCardContent>
        </IonCard>
    </SlideContent>
}

export default Section2